/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_TaskInputs */

const en_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const de_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const fr_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const es_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const it_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const nl_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const pl_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const fi_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const da_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const sv_story_bank_label_task = /** @type {(inputs: Story_Bank_Label_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

/**
* | output |
* | --- |
* | "Task" |
*
* @param {Story_Bank_Label_TaskInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_task = /** @type {((inputs?: Story_Bank_Label_TaskInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_TaskInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_task(inputs)
	if (locale === "fr") return fr_story_bank_label_task(inputs)
	if (locale === "es") return es_story_bank_label_task(inputs)
	if (locale === "it") return it_story_bank_label_task(inputs)
	if (locale === "nl") return nl_story_bank_label_task(inputs)
	if (locale === "pl") return pl_story_bank_label_task(inputs)
	if (locale === "fi") return fi_story_bank_label_task(inputs)
	if (locale === "da") return da_story_bank_label_task(inputs)
	if (locale === "sv") return sv_story_bank_label_task(inputs)
	return en_story_bank_label_task(inputs)
});